<div class="wrapper">
  <mat-list-item class="group mat-padding-none list-container" button="true" detail="false" (click)="navigateTo('/Home/Profile')" lines="none">
    <div class="list-item">
      <mat-icon class="icon-style"><img [src]="path + 'edit.svg'"  alt="Edit"/></mat-icon>
      <mat-label> MANAGE PROFILE </mat-label>
    </div>
  </mat-list-item>
  <mat-list-item class="group mat-padding-none list-container" button="true" detail="false" (click)="logout()" lines="none">
    <div class="list-item">
      <mat-icon class="icon-style"><img [src]="path + 'logout.svg'"  alt="Logout"/></mat-icon>
      <mat-label> LOGOUT </mat-label>
    </div>
  </mat-list-item>
</div>
